const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'SERVER_TYPE_DATAPOINT_SUCCESS') {
        return { ...state, [action.actionParams.id]: action.payload };
    }

    return state;
}

export default reducer;
